import { render, staticRenderFns } from "./PdfSettings.vue?vue&type=template&id=1e7a68f2"
import script from "@/views/modules/Administration/js/PdfSettings.js?vue&type=script&lang=js&external"
export * from "@/views/modules/Administration/js/PdfSettings.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports